import { Injectable, inject } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { phoneNumberValidator } from '../../validators/phone-number-validator';
import { ContactDeliveryAddress } from './contact-delivery-address.interface';
import { ContactDeliveryAddressFormGroup } from './contact-delivery-address-form-group.interface';

@Injectable()
export class ContactDeliveryAddressFormModel {
  public readonly form: FormGroup<ContactDeliveryAddressFormGroup>;

  constructor() {
    const formBuilder = inject(FormBuilder);

    this.form = formBuilder.group<ContactDeliveryAddressFormGroup>({
      label: new FormControl(null, Validators.maxLength(128)),
      kind: new FormControl('branch', {
        nonNullable: true,
      }),
      isPrimary: new FormControl(false, {
        nonNullable: true,
      }),
      country: new FormControl(null, Validators.maxLength(128)),
      city: new FormControl(null, Validators.maxLength(128)),
      street: new FormControl(null, Validators.maxLength(256)),
      postalCode: new FormControl(null, Validators.maxLength(32)),
      carrier: new FormControl('nova-poshta'),
      carrierName: new FormControl(null, Validators.maxLength(128)),
      branchCity: new FormControl(null, Validators.maxLength(128)),
      branchNumber: new FormControl(null, Validators.maxLength(64)),
      recipientName: new FormControl(null, Validators.maxLength(128)),
      recipientPhone: new FormControl<string | null>(null, {
        validators: [Validators.maxLength(32), phoneNumberValidator],
      }),
      notes: new FormControl(null, Validators.maxLength(512)),
    });
  }

  public reset(address?: Partial<ContactDeliveryAddress>): void {
    this.form.reset({
      label: address?.label ?? null,
      kind: address?.kind ?? 'branch',
      isPrimary: address?.isPrimary ?? false,
      country: address?.country ?? null,
      city: address?.city ?? null,
      street: address?.street ?? null,
      postalCode: address?.postalCode ?? null,
      carrier: address?.carrier ?? 'nova-poshta',
      carrierName: address?.carrierName ?? null,
      branchCity: address?.branchCity ?? null,
      branchNumber: address?.branchNumber ?? null,
      recipientName: address?.recipientName ?? null,
      recipientPhone: address?.recipientPhone ?? null,
      notes: address?.notes ?? null,
    });
  }
}
